/**
 * Mensaje de error que devuelve el backend.
 *
 * CodeIgniter responde los errores con ResponseTrait::fail, que arma
 * { status, error, messages: { errors: 'texto' } }.
 */
export function mensajeDeError(
  error,
  fallback = 'Ocurrió un error inesperado.',
) {
  const messages = error?.response?.data?.messages

  if (typeof messages?.errors === 'string' && messages.errors.length > 0) {
    return messages.errors
  }

  if (messages && typeof messages === 'object') {
    const detalles = Object.values(messages).filter(
      (detalle) => typeof detalle === 'string' && detalle.length > 0,
    )
    if (detalles.length > 0) {
      return detalles.join(' ')
    }
  }

  return fallback
}
